export const screens = Object.freeze({
  token: '/token',
  login: '/login',
  dashboard: '/',
  tenants: '/tenants',
  haulers: '/haulers',
  vendors: '/vendors',
  customers: '/customers',
  plants: '/plants',
  product: '/product_details',
  users: '/users',
  settings: '/settings',
  profile: '/profile',
  logout: '/logout',
  firefighter: '/firefighter',
})
export const ERROR = 'error'
export const ENVIRONMENT = Object.freeze({
  PROD: { ENV_NAME: 'PROD', ENV_TEXT: '' },
  DEV: { ENV_NAME: 'DEV', ENV_TEXT: ' -Development Env' },
  SIT: { ENV_NAME: 'SIT', ENV_TEXT: ' -SIT Env' },
  UAT: { ENV_NAME: 'UAT', ENV_TEXT: ' -UAT Env' },
  PERF: { ENV_NAME: 'PERF', ENV_TEXT: ' -PERF Env' },
  FTR: { ENV_NAME: 'FTR', ENV_TEXT: ' -FTR Env' },
} as const)
export const ICON_SIZE = Object.freeze({
  S: 18,
  M: 20,
  L: 24,
  XXL: 30,
  XXM: 40,
})
export const DashboardWidgetData = {
  tenants: { new: 1, total: 10 },
  plant: { new: 16, total: 80 },
  vendor: { new: 10, total: 50 },
  customer: { new: 7, total: 100 },
  hauler: { new: 1, total: 200 },
}
export const UI_CONSTANTS = Object.freeze({
  USER: 'user',
  AUTHORIZED_USER: 'auth_user',
  SET_PLANT_LIST: 'set_plants',
  SET_ACTIVE_JOB_LIST: 'set_active_job_list',
})
export const TEXT_VALIDATION = Object.freeze({
  MIN: 5,
  MAX: 500,
})
export const PAGESIZE = [
  { key: 10, value: '10' },
  { key: 15, value: '15' },
  { key: 20, value: '20' },
  { key: 25, value: '25' },
]
export const DEFAULT_PAGESIZE = { key: 10, value: '10' }

export const USER_ACTION = Object.freeze({
  ADD_USER_TYPE: 'addUserType',
  ADD_USER_INFO: 'addUserInfo',
  ADD_USER_ROLES: 'addRoleSelection',
  ADD_HAULER_SELECTION: 'addHaulerSelection',
  ADD_CUSTOMER_SELECTION: 'addCustomerSelection',
  REMOVE_USER_TYPE: 'removeUserType',
  REMOVE_USER_INFO: 'removeUserInfo',
  REMOVE_USER_ROLES: 'removeRoleSelection',
  REMOVE_HAULER_SELECTION: 'removeHaulerSelection',
  REMOVE_CUSTOMER_SELECTION: 'removeCustomerSelection',
  ADD_APPLICATION_CODES: 'addApplicationCodes',
})

export const APP_TYPE = Object.freeze({
  CUSTOMER_APP: 'CustomerApp',
  HAULER_APP: 'DispatcherApp',
  OWNER_APP: 'PrideOwnershipApp',
})

export const USERS_TYPES = Object.freeze({
  ATLAS_USER: 'Atlas User',
  EXTERNAL_USER: 'External User',
})

export const ROLE_DESCRIPTION_LENGTH = Object.freeze({
  MIN: 2,
  MAX: 100,
})

export const ROLE_NAME_LENGTH = Object.freeze({
  MIN: 4,
  MAX: 50,
})

export const PHONE_LENGTH = Object.freeze({
  MAX: 20,
})

export const EMAIL_LENGTH = Object.freeze({
  MAX: 100,
})
